import React from 'react';
import { Helmet } from 'react-helmet-async';
import StripeTestComponent from '../components/StripeTestComponent';
import Footer from '../components/common/Footer';

const StripeTest: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <Helmet>
        <title>Stripe Integration Test | VoiceVision</title>
        <meta name="description" content="Test Stripe payment integration for VoiceVision" />
      </Helmet>
      
      <StripeTestComponent />
      <Footer />
    </div>
  );
};

export default StripeTest;